import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import getTargetValue from 'services/forms/getTargetValue';
import translations from 'services/translations/translations';
import SelectInputFieldControlled from 'components/layout/forms/SelectInputFieldControlled';

import actionTypes from '../types/actionTypes';
import getOptions from '../services/getOptions';
import glassConnectionTypes from '../types/glassConnectionTypes';

const ChangeGlassMeetingSign = ({
  setActionType,
}: {
  setActionType: (actionType: string) => void;
}): JSX.Element | null => {
  const [glassConnectionType, setGlassConnectionType] = useState('leftlong');

  const { t } = useTranslation([translations.common]);

  const changeGlassMeetingSign = () => {
    window.ChangeGlassMeetingSign({ typeOfSign: glassConnectionType });
    setActionType(actionTypes.addWall);
  };

  return (
    <>
      <Row>
        <Col>
          <SelectInputFieldControlled
            id="glassConnectionTypes"
            label={t(`${translations.common}:Wall Properties.Wall Direction`)}
            onChange={(e: any) => setGlassConnectionType(getTargetValue(e))}
            name="glassConnectionTypes"
            required
            options={getOptions(
              glassConnectionTypes.map((value) => value.toString()),
              translations.common,
              'Glass Connection Types'
            )}
            value={glassConnectionType}
          />
        </Col>
      </Row>
      <PrimaryButton onClick={changeGlassMeetingSign}>
        {t(`${translations.common}:Add`).toLocaleUpperCase()}
      </PrimaryButton>
    </>
  );
};

export default ChangeGlassMeetingSign;
